/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentRunReport extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentRunReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentRunReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentRunReport>): BackgroundJobPayloadForAssessmentRunReport {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentRunReport(), model);
        BackgroundJobPayloadForAssessmentRunReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentRunReport>): BackgroundJobPayloadForAssessmentRunReport {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentRunReport.newInstance(<BackgroundJobPayloadForAssessmentRunReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentRunReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentRunReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentRunReport): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentRunReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the Assessment Run report
     */
    assessment_run_report_id: string;

    /**
     * ID of the report being generated
     */
    report_id: string;

}
